import { htmlContentStylesSx } from '@/components/content/DangerouslySetHtmlContent/styles/htmlContentStyles';
import { Box } from '@mui/material';
import { useEffect, useRef } from 'react';

export const DangerouslySetHtmlContent = ({
	html,
	executeScripts = false,
}: {
	html: string;
	executeScripts?: boolean;
}) => {
	const boxRef: any = useRef(null);

	useEffect(() => {
		if (!html || !boxRef.current) throw new Error("html prop cant't be null");

		if (!executeScripts) return;

		const range = document.createRange().createContextualFragment(html); // Create a 'tiny' document and parse the html string
		boxRef.current.innerHTML = ''; // Clear the container
		boxRef.current.appendChild(range); // Append the new content
	}, [executeScripts, html]);

	return <Box sx={htmlContentStylesSx} dangerouslySetInnerHTML={{ __html: html }} ref={boxRef} />;
};
